import { CONTRACT_ROLES, DOCSTORE_ROLES } from '../enums/admin-enum';
import { GSLModel } from './../../modules/home/components/srm/admin/create-edit-supplier-user/create-edit-supplier-user.component';
export enum PROFILE_FE_BE_MAPPING_FIELD {
    id = 'id',
    userName = 'sso',
    supplierID = 'supplierId',
    firstName = 'firstName',
    lastName = 'lastName',
    companyName = 'company',
    companyEmail = 'email',
    primaryLanguage = 'primaryLanguage',
    lastAccess = 'lastAccess',
    roles = 'roles',
    accessType = 'accessType'
}
export class Profile {
    id: number;
    firstName: string;
    lastName: string;
    companyName: string;
    companyEmail: string;
    userName: string;
    securityQuestion: string;
    anserwers: string;
    supplierID: string;
    lastAccess: Date;
    roles: string[];
    active?: boolean;
    authorized?: any[];
    gslInfos?: GSLModel[];
    sso?: string;
    accessType?: boolean;
    
    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.firstName = (params.firstName || '');
            this.lastName = (params.lastName || '');
            this.companyName = (params.companyName || '');
            this.companyEmail = (params.companyEmail || '');
            this.userName = (params.userName || '');
            this.supplierID = (params.supplierID || '');
            this.roles = (params.roles || '');
            this.accessType = (params.accessType || '');
            this.active = (params.active || '');
            this.authorized = (params.authorized || []);
            this.gslInfos = (params.gslInfos || []);
            this.sso = (params.sso || '');
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[PROFILE_FE_BE_MAPPING_FIELD.id];
        this.firstName = respObject[PROFILE_FE_BE_MAPPING_FIELD.firstName];
        this.lastName = respObject[PROFILE_FE_BE_MAPPING_FIELD.lastName];
        this.companyName = respObject[PROFILE_FE_BE_MAPPING_FIELD.companyName];
        this.companyEmail = respObject[PROFILE_FE_BE_MAPPING_FIELD.companyEmail];
        this.userName = respObject[PROFILE_FE_BE_MAPPING_FIELD.userName];
        this.supplierID = respObject[PROFILE_FE_BE_MAPPING_FIELD.supplierID];
        this.roles = respObject[PROFILE_FE_BE_MAPPING_FIELD.roles];
        const date = respObject[PROFILE_FE_BE_MAPPING_FIELD.lastAccess];
        this.lastAccess = date && date > 0 ? new Date(date) : new Date();
        this.accessType = respObject[PROFILE_FE_BE_MAPPING_FIELD.accessType];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[PROFILE_FE_BE_MAPPING_FIELD.id] = this.id;
        body[PROFILE_FE_BE_MAPPING_FIELD.lastName] = (this.lastName || '');
        body[PROFILE_FE_BE_MAPPING_FIELD.firstName] = (this.firstName || '');
        body[PROFILE_FE_BE_MAPPING_FIELD.companyName] = (this.companyName || '');
        body[PROFILE_FE_BE_MAPPING_FIELD.companyEmail] = this.companyEmail || '';
        body[PROFILE_FE_BE_MAPPING_FIELD.userName] = (this.userName || '');
        body[PROFILE_FE_BE_MAPPING_FIELD.supplierID] = (this.supplierID || '');
        body[PROFILE_FE_BE_MAPPING_FIELD.roles] = (this.roles || '');
        body[PROFILE_FE_BE_MAPPING_FIELD.accessType] = (this.accessType || '');
        return body;
    }
    hasContractRole(contractRole:CONTRACT_ROLES){
        return this.roles.some(role => role == contractRole);
    }

    hasAnyContractRole(contractRoles:CONTRACT_ROLES[]){
        for (let i = 0; i < contractRoles.length; i++) {
            if(this.hasContractRole(contractRoles[i])){
                return true;
            }
        }
        return false;
    }

    hasDocStoreRole(docStoreRole:DOCSTORE_ROLES){
        return this.roles.some(role => role == docStoreRole);
    }

    hasAnyDocStoreRole(docStoreRoles:DOCSTORE_ROLES[]){
        for (let i = 0; i < docStoreRoles.length; i++) {
            if(this.hasDocStoreRole(docStoreRoles[i])){
                return true;
            }
        }
        return false;
    }

    fullNameAndSSOToString() {
        return this.firstName + ', ' + this.lastName + ' ' + '(' + this.userName + ')';
    }
}

export class ProfileModel {
    active: string;
    authorized: any[];
    company: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
    gslInfo: GSLModel[];
    id: number;
    lastAccess: number;
    primaryLanguage: string;
    role: string;
    sso: string;
    supplierId: string;
    accessType: boolean;
}
